import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import './index.css';
import App from './App';
import { WagmiProvider } from 'wagmi';
import { QueryClientProvider } from '@tanstack/react-query';
import { wagmiAdapter, queryClient } from './config/wagmi';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const appTree = (
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

if (wagmiAdapter) {
  root.render(
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        {appTree}
      </QueryClientProvider>
    </WagmiProvider>
  );
  console.log('[Index] WagmiProvider mounted');
} else {
  console.warn('Missing REACT_APP_WALLETCONNECT_PROJECT_ID, Web3 features disabled');
  root.render(appTree);
}
